import $ from 'jquery';

export default {
  mounted() {
    this.headerChange();
    let { resetScrollView } = this.$options;
    if (resetScrollView) {
      $("body, html").animate({scrollTop: 0}, 1);
    }
  },
  methods: {
    headerChange() {
      let { title, description, keywords, headerTitle, headerType, backLink } = this.$options
      if (title) {
        document.title = title;
      }
      if (description || keywords) {
        const metaDiscre = document.head.children;
        const metaLength = metaDiscre.length;
        for (let i = 0; i < metaLength; i++) {
          let dis = metaDiscre[i];
        	let proper = dis.getAttribute('name');
        	if (proper === 'description') {
        		dis.setAttribute('content', description);
        	} else if (proper === 'keywords') {
        		dis.setAttribute('content', keywords);
          }
        }
      }
      if (headerTitle) {
        this.$store.dispatch('changeHeaderTitle', headerTitle);
      }
      if (headerType) {
        this.$store.dispatch("changeHeaderType", headerType);
        if (backLink) {
          this.$store.dispatch("changeBackLink", backLink);
        }
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch("navToggle", false);
  },
}



// WEBPACK FOOTER //
// ./src/lib/globalMixin.js